export default __webpack_public_path__ + "static/media/36I-102747_-17351_0.b179dd12.jpg";